export default __webpack_public_path__ + "static/media/rick-morty.56f49711.png";